/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getMemberGroupByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetMemberGroupById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getMemberGroupByIdIdRegExpTwo)]).optional()
});

export type GetMemberGroupById = zod.input<typeof GetMemberGroupById>;
export type GetMemberGroupByIdOutput = zod.output<typeof GetMemberGroupById>;
